/**
 *  @fileOverview Notification module
 *
 *  @author       Katie Hartrick
 *
 */

function NotificationModule () {
  this.init = function () {
    /**
     * Get all instances of notification banners
     */
    const notificationBanners = document.querySelectorAll('.notification')
    /**
     * Loop through notification banners, close selected banner
     */
    notificationBanners.forEach((notificationBanner) => {
      const closeButton = notificationBanner.querySelector('[data-action="notificationButton"]')
      /**
       * Add event listeners for close button
       */

      if (closeButton !== null) {
        closeButton.addEventListener('click', function () {
          notificationBanner.remove()
        })
      }
    })
  }
}

module.exports = NotificationModule
